import { render, staticRenderFns } from "./OkrEdit.vue?vue&type=template&id=c93a22e2&"
import script from "./OkrEdit.vue?vue&type=script&lang=js&"
export * from "./OkrEdit.vue?vue&type=script&lang=js&"
import style0 from "./OkrEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports